export default "__VITE_ASSET__DBWeKMW2__"